<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp;&nbsp;View Profile
    <div class="export_csv" mat-dialog-actions>
      <button
        stye="background-color: white !important;"
        class="clear_button_export rejbutt"
        style="float: right"
        (click)="onNoClick()"
        mat-raised-button
        color="primary"
      >
        Close
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="col-md-1"></div>
      <div class="profile_details">
        <mat-card class="page__content shadow p-3">
          <div
            class="profile_image"
            style="float: right; margin-top: 12px; margin-right: 39px"
          >
            <div *ngIf="avtar; else loggedOut">
              <img mat-card-image src="./assets/userImg.png" />
            </div>
            <ng-template #loggedOut>
              <img mat-card-image src="{{ profile_Image }}" />
            </ng-template>
            <div *ngIf="documentStatus == 'Verified'">
              <img
                src="./assets/verified.png"
                style="height: 39px; margin-left: 13px"
              />
              <p class="text_verified">
                <b style="font-size: 18px">Verified</b>
              </p>
            </div>
          </div>
          <div class="details">
            <!--For Traders -->
            <div *ngIf="datashowfarmer">
              <p><b>Farmer Name</b> : {{ personName }}</p>
              <p><b>Role</b> : {{ role }}</p>
              <p><b>Village</b> : {{ village }}</p>
              <p><b>Taluk</b> : {{ taluk }}</p>
              <p><b>District</b> : {{ district }}</p>
              <p><b>State</b> : {{ states }}</p>
              <p><b>Mobile Number</b> : {{ phoneNo }}</p>
              <p *ngIf="this.data.farmerData?.cropName">
                <b>Crop Type</b> : {{ this.data.farmerData?.cropName }}
              </p>
              <p>
                <b>{{
                  this.data.farmerData?.cropName == "Coconut"
                    ? "No Of Trees"
                    : "Harvest"
                }}</b>
                :
                {{
                  this.data.farmerData?.cropName == "Coconut"
                    ? numberOfTrees
                    : this.data.farmerData?.quantity
                    ? this.data.farmerData?.quantity
                    : harvest
                }}
              </p>
              <!-- need some changes regarding UNIT -->
              <p>
                <b>{{
                  this.data.farmerData?.cropName == "Coconut"
                    ? "Types of Trees"
                    : "Unit"
                }}</b>
                :
                {{
                  this.data.farmerData?.cropName == "Coconut"
                    ? treeType
                    : this.data.farmerData?.unitName
                    ? this.data.farmerData?.unitName
                    : unitName
                }}
              </p>
              <p><b>Customer Id </b> : {{ customerid }}</p>
            </div>
            <!---For farmer -->
            <!--For Traders -->
            <div *ngIf="datashowtrader">
              <p><b>Trader Name</b> : {{ personName }}</p>
              <p><b>Company </b> : {{ companyname }}</p>
              <p><b>Role</b> : {{ role }}</p>
              <p>
                <b>Address</b> :
                {{ address == null ? "Address not available." : address }}
              </p>
              <p><b>District</b> : {{ district }}</p>
              <p><b>State</b> : {{ states }}</p>
              <p><b>Mobile Number</b> : {{ phoneNo }}</p>
              <p>
                <b>Email</b> :
                {{ email == null ? "Email id not available." : email }}
              </p>
              <p>
                <b>Mandi</b> :
                {{ mandi == null ? "Mandi id not available." : mandi }}
              </p>
              <p><b>Commodity trade interested</b>: {{ commTradeInterest }}</p>
              <p><b>Frequency for requirement</b> : {{ reqFrequency }}</p>
              <p>
                <b>About the trader</b> :
                {{ aboutUs == null ? "About Us not available." : aboutUs }}
              </p>
            </div>
          </div>
          <!--For Traders -->
        </mat-card>
      </div>
    </div>
  </div>
  <!-- </div> -->
</div>
